import React, { useEffect, useState } from "react";

export default function Templates() {
  const API = "https://app.saravanabhava.in/api/templates.php";

  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: "", subject: "", content: "" });

  // 🔹 Fetch templates
  const fetchTemplates = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}?action=list`);
      const data = await res.json();
      if (data.status === "ok") {
        setTemplates(data.data || []);
      }
    } catch (err) {
      console.error("Fetch error", err);
    }
    setLoading(false);
  };

  // 🔹 Save (Create / Update)
  const saveTemplate = async () => {
    const action = editing ? "update" : "create";
    try {
      const res = await fetch(`${API}?action=${action}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(editing ? { ...form, id: editing } : form),
      });
      const data = await res.json();
      if (data.status === "ok") {
        alert("✅ Template saved");
        setForm({ name: "", subject: "", content: "" });
        setEditing(null);
        fetchTemplates();
      } else {
        alert("❌ " + (data.message || "Failed to save"));
      }
    } catch (err) {
      console.error("Save error", err);
    }
  };

  // 🔹 Delete
  const deleteTemplate = async (name) => {
    if (!window.confirm("Delete this template?")) return;
    try {
      const res = await fetch(`${API}?action=delete`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name }),
      });
      const data = await res.json();
      if (data.status === "ok") {
        alert("🗑 Deleted");
        fetchTemplates();
      } else {
        alert("❌ " + (data.message || "Delete failed"));
      }
    } catch (err) {
      console.error("Delete error", err);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">📑 Email Templates</h2>

      {/* Form */}
      <div className="border p-4 mb-4 rounded bg-gray-50">
        <h3 className="text-lg font-semibold mb-2">
          {editing ? "✏ Edit Template" : "➕ New Template"}
        </h3>
        <input
          type="text"
          placeholder="Template Name"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          className="border p-2 mb-2 w-full rounded"
        />
        <input
          type="text"
          placeholder="Subject"
          value={form.subject}
          onChange={(e) => setForm({ ...form, subject: e.target.value })}
          className="border p-2 mb-2 w-full rounded"
        />
        <textarea
          placeholder="Content (HTML allowed)"
          value={form.content}
          onChange={(e) => setForm({ ...form, content: e.target.value })}
          rows="5"
          className="border p-2 mb-2 w-full rounded"
        ></textarea>
        <button
          onClick={saveTemplate}
          className="px-4 py-2 bg-blue-600 text-white rounded"
        >
          {editing ? "Update" : "Create"}
        </button>
        {editing && (
          <button
            onClick={() => {
              setEditing(null);
              setForm({ name: "", subject: "", content: "" });
            }}
            className="ml-2 px-4 py-2 bg-gray-500 text-white rounded"
          >
            Cancel
          </button>
        )}
      </div>

      {/* Table */}
      {loading ? (
        <p>Loading...</p>
      ) : (
        <table className="w-full border-collapse border">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2">Name</th>
              <th className="border p-2">Subject</th>
              <th className="border p-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {templates.length === 0 ? (
              <tr>
                <td colSpan="3" className="text-center p-2">
                  No templates found
                </td>
              </tr>
            ) : (
              templates.map((tpl, index) => (
                <tr key={index}>
                  <td className="border p-2">{tpl.name}</td>
                  <td className="border p-2">{tpl.subject || "-"}</td>
                  <td className="border p-2">
                    <button
                      onClick={() => {
                        setEditing(tpl.name);
                        setForm({
                          name: tpl.name,
                          subject: tpl.subject || "",
                          content: tpl.content || "",
                        });
                      }}
                      className="px-3 py-1 bg-yellow-500 text-white rounded mr-2"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => deleteTemplate(tpl.name)}
                      className="px-3 py-1 bg-red-600 text-white rounded"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}
